import React from "react";
import { ApplicationInfo } from "./ApplicationInfo";

export const ApplicationPage = () => {
    return (
        <>
            <ApplicationInfo />
        </>
    );
};
